import { createSlice } from "@reduxjs/toolkit";
import { InitialPlasticWithDrawFormData } from "../../ConstantData/InitialData";
import { InitialPlasticWithDrawDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const plasticWithDrawSlice = createSlice({
  name: "plasticstock",
  initialState: {
    plasticWithDrawList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialPlasticWithDrawFormData,
    initialDuplicateData: InitialPlasticWithDrawDuplicateFormData,
  },
  reducers: {
    getAllPlasticWithDraws: (state, action) => {
      state.plasticWithDrawList = action.payload;
    },
    getPlasticWithDrawDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialPlasticWithDrawFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = {
        ...InitialPlasticWithDrawDuplicateFormData,
      };
    },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustPlasticWithDrawItem: (state, action) => {},
    deletePlasticWithDraw: () => {},
  },
});

export const plasticWithDrawSliceAction = plasticWithDrawSlice.actions;
export default plasticWithDrawSlice.reducer;
